import { SceneVideo } from "../gameData";

export function videoSrcOf(video: SceneVideo): string {
    return typeof video === "string" ? video : video.src;
}
